import { render, staticRenderFns } from "./70sczbf.vue?vue&type=template&id=fd7b9662&"
import script from "./70sczbf.vue?vue&type=script&lang=js&"
export * from "./70sczbf.vue?vue&type=script&lang=js&"
import style0 from "./70sczbf.vue?vue&type=style&index=0&id=fd7b9662&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports